import React, {
  useEffect, useState, useMemo, useRef, useCallback,
} from 'react'
import {
  Box, Text, IcoMoon, InfoIcon,
} from '@usap/uicomponents'
import useWmoEnabled from '../../../../../hooks/useWmoEnabled'
import WarningWmo from './WarningWmo'

export default function Warning({
  message,
  timeout = 15000,
  id,
  cb = () => {},
  closable = true,
  textSize = 'xsmall',
  iconSize = '24px',
  borderColor = '#E0E0E0',
}) {
  const isWmoEnabled = useWmoEnabled()
  const [show, setShow] = useState(true)
  const timeoutId = useRef(null)

  const handleClose = useCallback(() => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current)
    }
    setShow(false)
    cb()
  }, [cb])

  useEffect(
    () => {
      if (closable) {
        clearTimeout(timeoutId.current)
        const nextTimeoutId = setTimeout(handleClose, timeout)
        timeoutId.current = nextTimeoutId
      }
      return () => {
        clearTimeout(timeoutId.current)
      }
    },
    [closable, timeout, handleClose],
  )

  const style = useMemo(
    () => ({
      wrapperMargin: { vertical: 'medium' },
      wrapperBorder: { size: 'medium', side: 'left', color: '#FF9700' },
      iconWrapperPad: { horizontal: 'small' },
      iconColor: '#FF9700',
      containerPad: { vertical: 'small' },
      containerBorder: {
        borderColor: borderColor || '#E0E0E0',
        borderStyle: 'solid',
        borderWidth: '1px 1px 1px 0',
      },
    }),
    [borderColor],
  )

  if (!show) {
    return <></>
  }

  if (isWmoEnabled) {
    return <WarningWmo message={message} onClose={handleClose} />
  }

  return (
    <Box
      border={style.wrapperBorder}
      background="white"
      margin={style.wrapperMargin}
      id={id}
    >
      <Box
        direction="row"
        align="center"
        pad={style.containerPad}
        style={style.containerBorder}
      >
        <Box width="38px" pad={style.iconWrapperPad}>
          <IcoMoon
            size={iconSize}
            icon={InfoIcon}
            color={style.iconColor}
          />
        </Box>
        <Box width="calc(100% - 60px)">
          <Text size={textSize}>
            {message}
          </Text>
        </Box>
      </Box>
    </Box>
  )
}
